export default {
  GET_JOB_PHASES: (state) => state.jobPhases,
};
